(function () {
  var STORAGE_KEY = 'smsPopupDismissed';
  var TAB_CLOSED_KEY = 'smsPopupTabClosed';
  var KLAVIYO_PUBLIC_KEY = 'TMxRdS';
  var KLAVIYO_LIST_ID = 'S8ca7h';
  var SHOW_DELAY_MS = 3000;

  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.getElementById('SmsPopup');
    var tabWrapper = document.getElementById('SmsPopupTabWrapper');
    var tab = document.getElementById('SmsPopupTab');
    var tabClose = document.getElementById('SmsPopupTabClose');
    if (!modal) return;
    if (window.location.pathname.indexOf('/password') === 0) return;

    var form = modal.querySelector('#SmsPopupForm');
    var errorEl = modal.querySelector('.sms-popup__error');
    var submitButton = modal.querySelector('.sms-popup__submit');
    var spinner = submitButton.querySelector('.loading__spinner');
    var signupView = modal.querySelector('#SmsPopupSignupView');
    var successView = modal.querySelector('#SmsPopupSuccessView');
    var copyButton = modal.querySelector('#SmsPopupCodeCopy');
    var continueButton = modal.querySelector('#SmsPopupContinue');
    var countryToggle = modal.querySelector('#SmsPopupCountryToggle');
    var countryList = modal.querySelector('#SmsPopupCountryList');
    var countryDisplay = modal.querySelector('#SmsPopupCountryDisplay');
    var countryCodeInput = modal.querySelector('#SmsPopupCountryCode');

    if (countryToggle && countryList) {
      countryToggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = !countryList.hidden;
        countryList.hidden = isOpen;
        countryToggle.setAttribute('aria-expanded', String(!isOpen));
      });

      countryList.querySelectorAll('.sms-popup__country-option').forEach(function (option) {
        option.addEventListener('click', function () {
          var code = option.getAttribute('data-code');
          countryCodeInput.value = code;
          countryDisplay.textContent = '+' + code;
          countryList.hidden = true;
          countryToggle.setAttribute('aria-expanded', 'false');
        });
      });

      document.addEventListener('click', function (event) {
        if (!countryList.hidden && !countryToggle.contains(event.target) && !countryList.contains(event.target)) {
          countryList.hidden = true;
          countryToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    var showTab = function () {
      if (tabWrapper && !localStorage.getItem(TAB_CLOSED_KEY)) tabWrapper.hidden = false;
    };

    var hideTab = function () {
      if (tabWrapper) tabWrapper.hidden = true;
    };

    var dismiss = function () {
      localStorage.setItem(STORAGE_KEY, '1');
      showTab();
    };

    if (localStorage.getItem(STORAGE_KEY)) {
      showTab();
    } else {
      setTimeout(function () {
        if (localStorage.getItem(STORAGE_KEY)) return;
        modal.show(document.activeElement);
      }, SHOW_DELAY_MS);
    }

    if (tab) {
      tab.addEventListener('click', function () {
        hideTab();
        modal.show(tab);
      });
    }

    if (tabClose) {
      tabClose.addEventListener('click', function () {
        localStorage.setItem(TAB_CLOSED_KEY, '1');
        hideTab();
      });
    }

    // The shared modal-dialog component closes itself (click-outside,
    // Escape key, its own close button) without going through any listener
    // added here, so catch every close path in one place via the event it
    // always fires, rather than trying to wire up each trigger separately.
    document.body.addEventListener('modalClosed', function () {
      if (!modal.hasAttribute('open')) return;
      if (successView && !successView.hidden) {
        // Already subscribed this visit - no need to keep nudging them.
        localStorage.setItem(STORAGE_KEY, '1');
        hideTab();
        return;
      }
      dismiss();
    });

    modal.querySelector('.sms-popup__dismiss').addEventListener('click', function () {
      modal.hide();
    });

    var showSuccess = function () {
      signupView.hidden = true;
      successView.hidden = false;
    };

    if (copyButton) {
      copyButton.addEventListener('click', function () {
        navigator.clipboard.writeText('TWOS10').then(function () {
          copyButton.textContent = 'Copied';
          setTimeout(function () {
            copyButton.textContent = 'Copy';
          }, 2000);
        });
      });
    }

    if (continueButton) {
      continueButton.addEventListener('click', function () {
        modal.hide();
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      errorEl.hidden = true;
      errorEl.textContent = '';

      var phoneInput = modal.querySelector('#SmsPopupPhone');
      var countryCodeSelect = modal.querySelector('#SmsPopupCountryCode');
      var digits = phoneInput.value.replace(/\D/g, '');
      var countryCode = countryCodeSelect ? countryCodeSelect.value : '1';
      var isNorthAmerica = countryCode === '1';

      if (isNorthAmerica ? digits.length !== 10 : digits.length < 7) {
        errorEl.textContent = isNorthAmerica
          ? 'Enter a valid 10-digit phone number.'
          : 'Enter a valid phone number.';
        errorEl.hidden = false;
        return;
      }

      var phoneNumber = '+' + countryCode + digits;

      submitButton.classList.add('loading');
      submitButton.setAttribute('aria-disabled', 'true');
      if (spinner) spinner.classList.remove('hidden');

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + KLAVIYO_PUBLIC_KEY, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-10-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'SMS Popup',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    phone_number: phoneNumber,
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: KLAVIYO_LIST_ID,
                },
              },
            },
          },
        }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo subscribe request failed');
          localStorage.setItem(STORAGE_KEY, '1');
          showSuccess();
        })
        .catch(function () {
          errorEl.textContent = 'Something went wrong. Please try again.';
          errorEl.hidden = false;
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    });
  });
})();
